<template>
    <div class="service-list-item" @click='toDetail(service.id,service.shoppingCartId)'>
      <div class="banner">
        <img alt="" :src="service.pic | formatImgUrl(290,290,true)"/>
        <span class='teamTips' v-if='service.groupMemberNum'>{{service.groupMemberNum}}人团</span>
        <div class='dero_cont'>
            <div>
                <div class='dero_title' v-if='service.buyQuantity'>{{service.name}}x{{service.buyQuantity}}</div>
                <div class='dero_title' v-else>{{service.name}}</div>
                <div class='dero'>
                 
                  {{service.content}}
              
                </div>
            </div>

            <div class='price'>
                <div>{{service.priceText}}</div>
                <img v-if='type == 1' class="select" src="/images/home/plus_icon.png" @click.stop='select(service)'>
                <button class='chose_type' v-if='type == 2 && !enoughNowTag' @click.stop='select(service)'>规格</button>
            </div>
        </div>
      </div>
    </div>
</template>

<script>
  import zhugeObj from '@/assets/js/track'
  export default {
    name: 'list-item-new',
    props: {
      service: {
        type: Object,
        default: {}
      },
      type : {
        type: Number,
        default: 1
      },
      enoughNowTag : {
        type : Boolean,
        default : false
      }
    },
    computed: {
      
    },
    methods: {
      select(id){
        zhugeObj.track({
          title : '点击-具体服务项加号',
          content : {
            '服务项名称' : this.service.name
          }
        })
        this.$emit('select',id,this.service.shoppingCartId);
      },
      toDetail(serviceId,shoppingCartId){
        console.log(this.service,'休书')
        if(this.type == 2){
          this.$emit('changeRadio',this.service);
          return;
        }
        let cid = this.service.categoryId
        
        zhugeObj.track({
          title : '点击-具体服务项',
          content : {
            '服务项名称' : this.service.name
          }
        })

        this.$router.push({ name : 'serviceDetail' , query:{serviceId:serviceId}})
      }
    }
  }
</script>

<style scoped lang="scss">
  .teamTips{
    display: block;
    position: absolute;
    top:0;
    // width: 90px;
    padding:0px 10px;
    height: 32px;
    border-radius:4px;
    font-size: 20px;
    background: #6AA0A4;
    text-align: center;
    line-height: 32px;
    color:#fff;
    left:0;
  }
  .chose_type{
      font-size: 28px;
      color:#fff;
      background: #7ADFDF;
      height: 40px;
      border-radius:20px;
      padding-left: 12px;
      padding-right: 12px; 
      line-height: 40px;
  }
  .service-list-item{
    position: relative;
    .banner{
        display: flex;
        justify-content: flex-start;
        img{
            width: 160px;
            height: 160px;
            border-radius: 6px;
        }
    }
    .dero_cont{
        flex:1;
        margin-left: 20px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        .dero_title{
            font-size: 28px;
            color:#333333;
            font-weight: 500;
        }
        .dero{
            padding-right:50px;
            width: 300px;
            color:#999999;
            font-size: 24px;
            margin-top: 25px;
            word-break: break-all;
            text-overflow: ellipsis;
            -o-text-overflow: ellipsis;
            display: -webkit-box; /** 对象作为伸缩盒子模型显示 **/

            -webkit-box-orient: vertical; /** 设置或检索伸缩盒对象的子元素的排列方式 **/

            -webkit-line-clamp: 2; /** 显示的行数 **/

            overflow: hidden;  /** 隐藏超出的内容 **/
        }
        .price{
            color:#F24949;
            font-size: 26px;
            line-height: 44px;
            font-weight: 500;
            display: flex;
            justify-content: space-between;
            .yuan{
                font-size: 18px;
            }
        }
        .select{
            width: 44px;
            height: 44px;
        }
    }
  }
</style>
